import { useFeatureRollout } from '@rea-argonaut/experiment';
import { useAccountContext } from '../../app-kit/contexts/AccountContext/AccountContext';

export const useShowAVMLoggedOut = () => {
  const { isSignedIn } = useAccountContext();
  const showAVMData = useFeatureRollout('show_avm_data').isEnabled() || isSignedIn;

  return showAVMData;
};
